/* eslint-disable @typescript-eslint/no-explicit-any */
// import InstavisionCannotAddDeviceIcon from 'assets/instaview/CannotAddSelectedCamera.svg';
// import EventVideos30Days from 'assets/instaview/30DaysEventVideos.png';
// import InstaViewBasicAlerts from 'assets/instaview/basicMotionAlerts.png';
// import InstaViewDescriptiveAlerts from 'assets/instaview/descriptiveAIAlerts.png';
// import InstaViewProfessionalMonitoring from 'assets/instaview/professionalMonitoring.png';
// import LimitedSecurity from 'assets/instaview/limitedSecurity.png';
// import NoEventVideos from 'assets/instaview/noEventVideos.png';
// import InstavisionLogo from 'assets/instaview/logo.svg';
// import LoginIllustration from 'assets/instaview/loginIllustration.svg';
// import InstavisionMultiCameraAddedIllustration from 'assets/instaview/multiCameraIcon.svg';
// import InstavisionPaymentDeclinedIllustration from 'assets/instaview/paymentFailedIcon.svg';
// import InstavisionPaymentSuccessfulIllustration from 'assets/instaview/paymentSuccessIllustration.svg';
// import InstavisionFreeTrialActivationIllustration from 'assets/instaview/trialActivationIllustration.svg';
import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';
// import { partnerAssets } from '../partnerAssets';
// returns the config and accepts an optional translation function
export const getInstaViewConfig = (
  t?: TFunction
): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.instaview;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'InstaVision',
    typeOfCompany: 'Inc.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'InstaVision'
      },
      'Welcome to InstaVision'
    ) as string,
    // loginIllustration: partnerAssets.loginIllustration,
    // logo: InstavisionLogo,
    // logo: partnerAssets.logo,
    universalLink: process.env.REACT_APP_UNIVERSAL_LINK,
    // paymentSuccessfull: partnerAssets.paymentSuccessfulIcon,
    // paymentFailed: partnerAssets.paymentFailedIcon,
    // multiCameraAddedIllustration: partnerAssets.AllCamerasAddedToAccountIcon,
    // cannotAddDeviceIcon: partnerAssets.CannotAddSelectedCameraIcon,
    // trialActivationIcon: partnerAssets.FreeTrialActivatedIcon,
    label: 'InstaVision',
    supportEmail: 'support@instavision.ai',
    supportEmail2: 'info@instavision.ai',
    phoneNumber: '+1 (877) 916-3025',
    companyAddress: '2244 Faraday Avenue, Carlsbad, CA 92008',
    // freeTrialLivingRoom: EventVideos30Days,
    // freeTrialPersonDetected: partnerAssets.descriptiveAIAlertsImg,
    // freeTrialCriticalAlerts: partnerAssets.professionalMonitoringImg,
    // skipFreeTrialLivingRoom: partnerAssets.noEventVideosImg,
    // skipFreeTrialTheft: partnerAssets.limitedSecurityImg,
    // skipFreeTrialFalseAlerts: partnerAssets.basicMotionAlertsImg,
    updateDeteOfPrivacyPolicy: 'July 09, 2024',
    updateDeteOfTermsOfService: 'July 10, 2024',
    // smallWhiteLogo: partnerAssets.logo,
    promo30DaysEventVideoId: 't3TcEt0eCps',
    promoDescriptiveAlertsVideoId: 'q1w35gBFTbI',
    promoProfessionMonitoringVideoId: 'yeMJe6Bf8Bk',
    iosAppLink:
      'https://apps.apple.com/in/app/instavision-smart-safe-home/id6479250008',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=ai.instaview.guardian'
  };
};

// Export a static config for bundling/tree-shaking
const instaViewConfig = getInstaViewConfig();
export default instaViewConfig;
